<template>
    <div
        v-if="isTwoPack"
        role="radiogroup"
        class="cz2__step-groups-pop-toggle-wrapper"
    >
        <sb-button
            v-if="isSpellingBee"
            @click="emitChange(0)"
            :variant="isActivePop(0) ? 'primary' : 'tertiary'"
            heightVariant="medium"
        >
            {{ $t('POP_1') }}
        </sb-button>

        <span class="cz2__step-groups-pop-toggle" v-else>
            <input
                type="radio"
                name="activePop"
                id="pop1"
                value="pop1"
                :disabled="!enablePop1"
                :checked="isActivePop(0)"
                @change="emitChange(0)"
            />
            <label
                for="pop1"
                :class="headerFontClass"
            >
                {{ $t('POP_1') }}
            </label>
        </span>

        <sb-button
            v-if="isSpellingBee"
            @click="emitChange(1)"
            :variant="isActivePop(1) ? 'primary' : 'tertiary'"
            heightVariant="medium"
        >
            {{ $t('POP_2') }}
        </sb-button>

        <span class="cz2__step-groups-pop-toggle" v-else>
            <input
                type="radio"
                name="activePop"
                id="pop2"
                value="pop2"
                :disabled="!enablePop2"
                :checked="isActivePop(1)"
                @change="emitChange(1)"
            />
            <label
                for="pop2"
                :class="headerFontClass"
            >
                {{ $t('POP_2') }}

                <img
                    v-if="hasAlert"
                    src="../assets/icons/alert.svg"
                    alt="Warning"
                    width="30"
                    height="27"
                    class="cz2__step-groups-pop-toggle-alert"
                >
            </label>
        </span>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__step-groups-pop-toggle-wrapper {
            position: relative;
            margin-left: -16px;
            display: flex;
            gap: 16px;

            .cz2__step-groups-pop-toggle {
                position: relative;

                height: 40px;
                flex: 1 1 0%;
                display: flex;

                font-size: 32px;
                text-transform: uppercase;
                color: color(primaryWhite);

                input[type='radio'] {
                    margin: 0;
                    appearance: none;
                    border-radius: 28px;

                    width: 100%;
                    height: 100%;

                    background-color: color(v2Red);

                    cursor: pointer;

                    &:checked {
                        border: 3px solid black;
                        background-color: white;
                    }

                    &:checked ~ label {
                        color: black;
                    }

                    &:disabled {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }
                }

                label {
                    position: absolute;

                    pointer-events: none;

                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .cz2__step-groups-pop-toggle-alert {
                        margin-top: 2px;
                        margin-left: 8px;
                    }
                }
            }

            @include respond-above(lg) {
                .cz2__step-groups-pop-toggle {
                    height: 56px;
                }
            }
        }
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   ▗▄▄▖▗▄▄▖ ▗▄▄▄▖▗▖   ▗▖   ▗▄▄▄▖▗▖  ▗▖ ▗▄▄▖    ▗▄▄▖ ▗▄▄▄▖▗▄▄▄▖
    //  ▐▌   ▐▌ ▐▌▐▌   ▐▌   ▐▌     █  ▐▛▚▖▐▌▐▌       ▐▌ ▐▌▐▌   ▐▌
    //   ▝▀▚▖▐▛▀▘ ▐▛▀▀▘▐▌   ▐▌     █  ▐▌ ▝▜▌▐▌▝▜▌    ▐▛▀▚▖▐▛▀▀▘▐▛▀▀▘
    //  ▗▄▄▞▘▐▌   ▐▙▄▄▖▐▙▄▄▖▐▙▄▄▖▗▄█▄▖▐▌  ▐▌▝▚▄▞▘    ▐▙▄▞▘▐▙▄▄▖▐▙▄▄
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    #cz2.cz2__is-sb {
        .cz2__step-groups-pop-toggle-wrapper {
            margin-left: 0;
            padding-bottom: 16px;
            margin: 0 auto;
            width: 100%;
        }
    }

    #cz2.cz2.cz2__is-kiosk.cz2__is-sb {
        .cz2__step-groups-pop-toggle-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            max-width: 100vw !important;
            margin-left: 8px;
        }
        .cz2__sb-button {
            height: 56px;
        }
    }

    #cz2.cz2.cz2__is-mariners {
        .cz2__step-groups-pop-toggle {
            input[type='radio'] {
                background-color: color(ssGreenDark);
                color: white;

                &:checked {
                    border-color: color(ssGreenDark);
                    background-color: color(ssYellow);
                }

                &:checked ~ label {
                    color: color(ssGreenDark);
                }
            }
        }
    }
</style>

<script>
    import SbButton from './SbButton.vue';

    export default {
        components: {
            SbButton,
        },

        computed: {
            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            isSpellingBee() {
                return this.$store.state.isSpellingBee;
            },

            headerFontClass() {
                return this.$store.getters.headerFontClass;
            },

            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },

            alertGroups() {
                return this.$store.state.customizer.alertGroups;
            },

            viewController() {
                return this.$store.state.customizer.viewController;
            },

            enablePop1() {
                if (this.alertGroups.length) {
                    return false;
                }
                return true;
            },

            enablePop2() {
                if (this.alertGroups.length) {
                    return false;
                }
                const pop2Controller = this.$store.getters.popControllers[1];
                const editsMade = this.$store.state.customizer.dirtyByController[pop2Controller.id];
                const isSecondPop = this.viewController === pop2Controller;
                const pop2SeenGroups = this.$store.state.customizer.seenGroupsByController[pop2Controller.id];

                return editsMade || isSecondPop || pop2SeenGroups?.length;
            },

            hasAlert() {
                const pop2Id = this.$store.getters.popControllers[1].id;

                return this.$store.state.customizer.alertGroupsByController[pop2Id]?.length;
            },
        },

        methods: {
            isActivePop(index) {
                return this.viewController === this.$store.getters.popControllers[index];
            },

            emitChange(index) {
                this.$emit('switch', index);
            },
        },
    };
</script>
